import Svg, { ClipPath, Defs, G, Path, SvgProps } from "react-native-svg"

function GiftSvg(props:SvgProps) {
  return (
    <Svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      {...props}
    >
      <G clipPath="url(#clip0_2132_3338)">
        <Path
          d="M11.307 4.5A1.846 1.846 0 0012 3.099a2.039 2.039 0 00-2.098-2.097 1.846 1.846 0 00-1.34.62c-.233.27-.423.575-.562.904a3.434 3.434 0 00-.563-.905A1.846 1.846 0 006.098 1 2.039 2.039 0 004 3.1a1.846 1.846 0 00.62 1.34c.023.02.048.04.072.062H7.5c-.61-.065-1.625-.286-2.218-.813A.856.856 0 015 3.063a1.039 1.039 0 011.036-1.062h.03a.856.856 0 01.625.281c.525.593.743 1.611.808 2.219h1c.074-.657.313-1.656.813-2.218a.856.856 0 01.624-.281h.031A1.038 1.038 0 0111 3.067a.855.855 0 01-.282.62h.001c-.593.525-1.609.748-2.219.813h2.807zM2.5 8.667h5v-.666h-5v.666zM8.5 8v.667h5v-.666h-5z"
          fill="#9C6E00"
        />
        <Path
          d="M7.427 13.428a.25.25 0 01-.177.073h1.5a.25.25 0 01-.25-.25V4.5h-1v8.75a.25.25 0 01-.073.177z"
          fill="#9C6E00"
        />
        <Path
          d="M4.692 4.5H2.5a1 1 0 00-1 1v2a1 1 0 001 1v4a1 1 0 001 1h3.75a.25.25 0 00.25-.25V8.668h-5v-.666h5V4.5H4.692zM13.5 4.5h-5V8h5v.667h-5v4.584a.25.25 0 00.25.25h3.75a1 1 0 001-1v-4a1 1 0 001-1v-2a1 1 0 00-1-1z"
          fill="#FFE89E"
        />
      </G>
      <Defs>
        <ClipPath id="clip0_2132_3338">
          <Path fill="#fff" d="M0 0H16V16H0z" />
        </ClipPath>
      </Defs>
    </Svg>
  )
}

export default GiftSvg
